import { render, staticRenderFns } from "./travelExpensesEdit.vue?vue&type=template&id=13724d53&scoped=true&"
import script from "./travelExpensesEdit.vue?vue&type=script&lang=js&"
export * from "./travelExpensesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13724d53",
  null
  
)

export default component.exports